/**
 * Select calls and format them for search.
 */
const selectCalls = state => {
  const callQueue = state.emergencyCalls.callQueue || {};

  const calls = Object.keys(callQueue).map(k => ({
    ...(callQueue[k] || {}),
    _callId: k,
    _datasetName: 'calls',
  }));

  return {
    keys: ['_callId'],
    data: calls,
  };
};

export default selectCalls;
